import { baseUrl as initialBaseUrl } from '@fs/zion-config'
import { getSessionId } from '@fs/zion-session'

const localhostUrl = ''

// initialBaseUrl is null when we are running unit tests.
// if (initialBaseUrl) {
//   localhostUrl = /localhost/.test(window.location.href) ? `http://localhost:${window.location.port}` : ''
// }

const baseUrl = localhostUrl || initialBaseUrl || 'https://integration.familysearch.org'
const baseUrlMap = {
  'https://beta.familysearch.org': 'https://sg31b0.familysearch.org',
  'https://integration.familysearch.org': 'https://sg32i0.familysearch.org',
  'https://www.familysearch.org': 'https://sg30p0.familysearch.org',
  'https://familysearch.org': 'https://sg30p0.familysearch.org',
}

const apiBaseUrlMap = {
  'https://beta.familysearch.org': 'https://apibeta.familysearch.org',
  'https://integration.familysearch.org': 'https://api-integ.familysearch.org',
  'https://www.familysearch.org': 'https://api.familysearch.org',
  'https://familysearch.org': 'https://api.familysearch.org',
}

baseUrlMap[localhostUrl] = localhostUrl
apiBaseUrlMap[localhostUrl] = localhostUrl

export const SG_BASE_URL = `${baseUrlMap[baseUrl]}`
export const VOLUNTEER_BASE_URL = `${baseUrlMap[baseUrl]}/service/records/volunteer/orchestration`
// Can be localhost:5000 to send network requests through local proxy if we are on localhost
export const FS_BASE_URL = baseUrlMap[baseUrl]
export const RMS_BASE_URL = `${baseUrlMap[baseUrl]}/service/records/rms`
export const familySearchCisId = 'cis.wkca.MMMM-M932'

export const headers = {
  accept: 'application/json',
  Authorization: `Bearer ${getSessionId()}`,
  'FS-User-Agent-Chain': 'RIP-shared-image-viewer',
}

export const localhostUserAgent = { 'User-Agent': 'fs-internal-RIP' } // Ask Patrick about this

// App attribution values
export const R2AppName = 'RII'
export const NameApp = 'NAME_APP'
export const FullNameApp = 'FULL_NAME_WEB'
export const FamilyReviewApp = 'FAMILY_REVIEW'
export const FullTextApp = 'FULLTEXT_WEB'

export const reasonIdSame = 147760 // The value is the same as the most recent value.  Just marking the field as reviewed basically
export const reasonIdChanged = 127170 // The user is adding a new value

// NOTE: This was requested by Dave Wilkes and Janell Vasquez because missionaries were putting 60% of removed images back into circulation.
export const REMOVE_BAD_IMAGES = false
